import styles from "./style.module.css";
import { useContext, useEffect, useState } from "react";

import Input from "../../../components/Common/Input/Input";


// import dataContext from "../../../context/dataContext";
import { validate } from "../../Signup/Signup/validate";
import SignButton from "../../../components/Common/SignButton/SignButton";
import mainContext from "../../../context/mainContext";

import { useNavigate } from "react-router-dom";
import userRequests from "../../../components/api/userRequests";
import { getAuth } from "firebase/auth";

export default function ChangePassword() {

  const navigate = useNavigate();
  const [valid, setValid] = useState([]);
  const { header: { setPageName }, loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext)
  const [errorMessage, setErrorMessage] = useState("")
  useEffect(() => {
    setPageName("Change Password");
    return () => setPageName("")
  }, [])

  // const { setUserDetails } = useContext(dataContext)

  const getDatafromForm = (formData) => ({
    oldPassword: formData.get("oldPassword"),
    newPassword: formData.get("newPassword"),
    confirmPassword: formData.get("confirmPassword"),
  })

  const onSubmit = async (e) => {
    e.preventDefault();

    const body = getDatafromForm(new FormData(e.currentTarget))

    const checkResult = validate(body)

    setValid(checkResult)

    if (checkResult.length) return;
    if (body.oldPassword == body.newPassword) {
      setErrorMessage("Oops! It seems like you entered your current password as the new one. Please choose a different password");
      return
    }
    if (body.newPassword != body.confirmPassword) {
      setErrorMessage("Oops! It looks like your passwords don't match. Please try again");
      return
    }

    try {
      let auth = getAuth()
      setLoaderFetch(true);
      let res = await userRequests.changePass(auth.currentUser, body.newPassword)
      setErrorMessage(res.message)
      setTimeout(() => {

        navigate("/settings")
      }, 2300)
    } catch (err) {
      setErrorMessage(err.message)
      console.log(err);
    } finally {
      setLoaderFetch(false);

    }
  };


  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage("")
      }, 2000)
    }
  }, errorMessage)
  return (
    <form className={styles["ChangePassword"]} onSubmit={onSubmit} style={window.buildType === "iPhone" ? { minHeight: "85dvh" } : {}}>
      <Input
        legend="Old Password"
        content="Enter old password"
        type="password"
        name="oldPassword"
        valid={!valid.includes("oldPassword")}
      />
      <Input
        legend="New Password"
        content="Enter new password"
        type="password"
        name="newPassword"
        valid={!valid.includes("newPassword")}
      />
      <Input
        legend="Confirm Password"
        content="Enter confirm password"
        type="password"
        name="confirmPassword"
        valid={!valid.includes("confirmPassword")}
      />

      {errorMessage && <div style={{ dispaly: "flex", justifyContent: "center", alignItems: "center", padding: "1rem" }}>{errorMessage}</div>}
      <div className={styles.btnHolder}>
        <SignButton content="submit" type="submit" />
      </div>
    </form>
  );
}

